export default function MensajeToken({ mensajeError, logout }) {
    return (
        <div className="fixed inset-0 flex justify-center items-center h-screen w-full bg-black/60 backdrop-blur-sm transition-opacity z-50 p-4">
            {/* Contenedor Principal con Glassmorphism */}
            <div className="relative transform overflow-hidden rounded-2xl bg-gray-900/90 border border-gray-700 shadow-2xl transition-all sm:w-full sm:max-w-md">
                
                <div className="p-8 text-center">
                    {/* Icono con gradiente y pulso sutil */}
                    <div className="mb-6 inline-flex justify-center items-center w-16 h-16 rounded-full bg-yellow-500/10 border border-yellow-500/20 shadow-[0_0_15px_rgba(234,179,8,0.1)]">
                        <svg
                            className="w-8 h-8 text-yellow-500"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth="2"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                            />
                        </svg>
                    </div>

                    {/* Texto */}
                    <h3 className="mb-3 text-xl font-extrabold text-white tracking-tight">
                        SESIÓN EXPIRADA
                    </h3>
                    <p className="text-gray-400 text-sm leading-relaxed">
                        Tu sesión ha finalizado por seguridad. Por favor, vuelve a ingresar.
                    </p>

                    {/* Botón con estilo Moderno */}
                    <div className="mt-8">
                        <button
                            type="button"
                            onClick={logout}
                            className="w-full py-3 px-4 inline-flex justify-center items-center gap-2 rounded-xl font-bold bg-blue-600 text-white hover:bg-blue-500 active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-900 transition-all duration-200 shadow-lg shadow-blue-900/20"
                        >
                            INICIAR SESIÓN
                        </button>
                    </div>
                </div>

                {/* Detalle decorativo inferior */}
                <div className="h-1.5 w-full bg-gradient-to-r from-blue-600 to-indigo-600"></div>
            </div>
        </div>
    )
}